<main class="archetypes-page">
  <app-ui-page-header
    title="Arquétipos"
    subtitle="Defina o fluxo, os modelos e as políticas que originam novas versões de agentes."
    [count]="visibleArchetypes().length"
    density="compact"
    [divider]="false"
  >
    <div actions class="header-actions">
      <button appButton variant="secondary" type="button" [disabled]="loading()" (click)="refresh()">
        <ng-icon name="heroArrowPath" size="16" aria-hidden="true" />
        Atualizar
      </button>
      <button appButton variant="primary" type="button" (click)="create()">
        <ng-icon name="heroPlus" size="16" aria-hidden="true" />
        Novo arquétipo
      </button>
    </div>
  </app-ui-page-header>

  <section appUiFilterBar aria-label="Filtros de arquétipos">
    <label appUiFilterSearch>
      <span class="sr-only">Buscar arquétipos</span>
      <ng-icon name="heroMagnifyingGlass" size="16" aria-hidden="true" class="search-icon" />
      <input
        appInput
        leadingIcon
        type="search"
        placeholder="Buscar por nome, categoria ou descrição"
        [value]="search()"
        (input)="setSearch($event)"
      />
    </label>

    <div appUiFilterField>
      <span appUiFilterLabel>Origem</span>
      <button appSelect type="button" [ngpSelectValue]="scope()" (ngpSelectValueChange)="setScope($event)">
        <span>{{ scopeLabel() }}</span>
        <div *ngpSelectPortal appSelectDropdown>
          @for (option of scopeOptions; track option.value) {
            <div appSelectOption [ngpSelectOptionValue]="option.value">{{ option.label }}</div>
          }
        </div>
      </button>
    </div>

    <div appUiFilterField>
      <span appUiFilterLabel>Status</span>
      <button appSelect type="button" [ngpSelectValue]="status()" (ngpSelectValueChange)="setStatus($event)">
        <span>{{ statusLabel() }}</span>
        <div *ngpSelectPortal appSelectDropdown>
          @for (option of statusOptions; track option.value) {
            <div appSelectOption [ngpSelectOptionValue]="option.value">{{ option.label }}</div>
          }
        </div>
      </button>
    </div>

    @if (hasFilters()) {
      <div appUiFilterActions>
        <button appButton variant="ghost" type="button" (click)="clearFilters()">Limpar</button>
      </div>
    }
  </section>

  <section class="archetypes-content" aria-live="polite">
    @if (loading() && archetypes().length === 0) {
      <div class="loading-state"><app-ui-spinner [size]="32" /><span>Carregando arquétipos</span></div>
    } @else if (visibleArchetypes().length === 0) {
      <app-ui-empty-state
        icon="heroSquares2x2"
        title="Nenhum arquétipo encontrado"
        description="Crie um fluxo do zero ou altere os filtros da busca."
      >
        <button actions appButton variant="primary" type="button" (click)="create()">Novo arquétipo</button>
      </app-ui-empty-state>
    } @else {
      <app-ui-record-list>
        @for (archetype of visibleArchetypes(); track archetype.id) {
          <li appUiRecordRow>
            <button appUiRecordRowButton type="button" (click)="open(archetype)">
              <span appUiRecordRowMain>
                <span appUiRecordRowIcon><ng-icon name="heroCpuChip" size="18" aria-hidden="true" /></span>
                <span appUiRecordRowBody>
                  <span class="record-heading">
                    <span appUiRecordRowTitle>{{ archetype.name }}</span>
                    <span appBadge [tone]="archetype.origin === 'system' ? 'neutral' : 'accent'" size="xs">
                      {{ archetype.origin === 'system' ? 'Sistema' : 'Business' }}
                    </span>
                  </span>
                  <span appUiRecordRowDescription>{{ archetype.description || 'Sem descrição.' }}</span>
                </span>
              </span>
            </button>

            <span appUiRecordRowMeta>
              <span>{{ versionLabel(archetype) }}</span>
              <span>{{ archetype.agentsUsingCount }} agente(s)</span>
              <span>Atualizado {{ updatedLabel(archetype.updatedAt) }}</span>
            </span>

            <span appUiRecordRowActions>
              @if (busyId() === archetype.id) {
                <app-ui-spinner [size]="18" [stroke]="2" />
              } @else if (archetype.origin === 'system') {
                <button appButton variant="ghost" size="sm" type="button" (click)="duplicate(archetype, $event)">
                  <ng-icon name="heroDocumentDuplicate" size="15" aria-hidden="true" />
                  Duplicar
                </button>
              } @else {
                <button appUiIconButton variant="ghost" size="sm" type="button" aria-label="Arquivar arquétipo" (click)="archive(archetype, $event)">
                  <ng-icon name="heroArchiveBox" size="16" aria-hidden="true" />
                </button>
              }
              <button appUiIconButton variant="ghost" size="sm" type="button" aria-label="Abrir arquétipo" (click)="open(archetype)">
                <ng-icon name="heroChevronRight" size="16" aria-hidden="true" />
              </button>
            </span>
          </li>
        }
      </app-ui-record-list>
    }
  </section>
</main>
